import { render, staticRenderFns } from "./MediumImage.vue?vue&type=template&id=21393fac&scoped=true&"
import script from "./MediumImage.vue?vue&type=script&lang=ts&"
export * from "./MediumImage.vue?vue&type=script&lang=ts&"
import style0 from "./MediumImage.vue?vue&type=style&index=0&id=21393fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21393fac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VImg,VProgressCircular,VRow})
